import { createStore } from 'redux'
import { toJSON, fromJSON } from 'transit-immutable-js'

import workApp from './reducers'

const savedState = {
  data: fromJSON(localStorage.getItem('workTrackerStateV1')) || undefined,
}
const devTools =
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
export const store = createStore(workApp, savedState, devTools)

store.subscribe(() => {
  const state = store.getState()
  localStorage.setItem('workTrackerStateV1', toJSON(state.data))
})



// WEBPACK FOOTER //
// ./src/model/store.js